import { render, staticRenderFns } from "./EditDid.vue?vue&type=template&id=22d9db62&"
import script from "./EditDid.vue?vue&type=script&lang=js&"
export * from "./EditDid.vue?vue&type=script&lang=js&"
import style0 from "./EditDid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditDid.vue"
export default component.exports